(function ( $ ) {
  /** Scroll to jquery Plugin.
   *
   * when this plugin is activated on a link it takes its href value,
   * and if an element is found in the page, the page scroll to this element.
   *
   * example:
   *   <a href="#my-div">Click to scroll</a>
   *     ...
   *   <div id="#my-div"></div>verso il centro
   * $('.rb-scroll-to').RBScrollTo();
   */
  $.fn.RBScrollTo = function (options) {
    return this.each(function() {

      var settings = $.extend({
        destination: $($(this).attr('href')),
        duration: '200',

      }, options);

      $(this).on('click', function (e) {

        if (settings.destination.length) {
          $("html,body")
            .stop()
            .animate({
              scrollTop: settings.destination.offset().top
            },
            settings.duration);
        }
        e.preventDefault();

      });
    });
  }

})(window.jQuery);
